import { render, staticRenderFns } from "./Step4CopyStyle.vue?vue&type=template&id=77881268&scoped=true"
import script from "./Step4CopyStyle.vue?vue&type=script&lang=js"
export * from "./Step4CopyStyle.vue?vue&type=script&lang=js"
import style0 from "./Step4CopyStyle.vue?vue&type=style&index=0&id=77881268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77881268",
  null
  
)

export default component.exports